import React from "react";

const Payment = () => {
  return (
    <div>
      <h1>Payment System Comming Soon....</h1>
    </div>
  );
};

export default Payment;
